import { setupTimeGetter } from './util/time';
import { setupLogger, LogLevel } from 'lib-common';

declare global {
  interface Window {
     _env_: any;   // <--- ADD THIS LINE
    env: ApplicationEnv.Env;
  }
  namespace ApplicationEnv {
    interface Env {
      API_GATEWAY_URL: string;
      SAP_CDC_CLIENT_ID: string;
      SAP_CDC_DOMAIN: string;
      SAP_CDC_LOGOUT: string;
      MANAGE_USERS_SAP_CDC: string;
      STUB_TIME?: string;
      DISABLE_AUTH?: string;
      LOG_LEVEL?: keyof LogLevel;
      GA4_TRACKING_ID: string;
      NODE_ENV?: string;
      UNDER_MAINTENANCE?: string;
      FEATURE_FLAGS_URL: string;
      FEATURE_FLAGS_CLIENT_KEY: string;
      REGION?: string;
      MY_CAMBRIDGE_LINK?: string
    }
  }
}

declare const process: {
  env: Record<string, string | undefined>;
};

const runtime = window._env_ || process.env;

const env: ApplicationEnv.Env = {
  API_GATEWAY_URL: runtime.REACT_APP_API_GATEWAY_URL || '',
  SAP_CDC_CLIENT_ID: runtime.REACT_APP_SAP_CDC_CLIENT_ID || '',
  SAP_CDC_DOMAIN: runtime.REACT_APP_SAP_CDC_DOMAIN || '',
  SAP_CDC_LOGOUT: runtime.REACT_APP_SAP_CDC_LOGOUT || '',
  MANAGE_USERS_SAP_CDC: runtime.REACT_APP_MANAGE_USERS_SAP_CDC || '',
  STUB_TIME: runtime.REACT_APP_STUB_TIME,
  DISABLE_AUTH: runtime.REACT_APP_DISABLE_AUTH,
  LOG_LEVEL: runtime.REACT_APP_LOG_LEVEL,
  GA4_TRACKING_ID: runtime.REACT_APP_GA4_TRACKING_ID || '',
  NODE_ENV: runtime.NODE_ENV,
  UNDER_MAINTENANCE: runtime.REACT_APP_UNDER_MAINTENANCE,
  FEATURE_FLAGS_URL: runtime.REACT_APP_FEATURE_FLAGS_URL || '',
  FEATURE_FLAGS_CLIENT_KEY: runtime.REACT_APP_FEATURE_FLAGS_CLIENT_KEY || '',
  REGION: runtime.REACT_APP_REGION,
  MY_CAMBRIDGE_LINK: runtime.REACT_APP_MY_CAMBRIDGE_LINK,
};

export const configureEnvironment = (): Promise<ApplicationEnv.Env> =>
  Promise.resolve().then(() => {
    window.env = env;
    
    setupLogger({ level: env.LOG_LEVEL });
    setupTimeGetter();

    logger.debug({
      message: 'Environment configured',
      data: {
        NODE_ENV: env.NODE_ENV,
        LOG_LEVEL: env.LOG_LEVEL,
        REGION: env.REGION,
      },
    });
    return env;
  });
